import { StyleSheet, View, Text } from "@react-pdf/renderer";
import { TableRowProps } from "./TableRowProps";


export function TableRow({ name, value }: TableRowProps) {

    const styles = StyleSheet.create({
        center: {
            flexDirection: "row",
        },
        border: {
            borderColor: "rgb(51, 102, 153)",
            border: "solid 1px 1px 1px 1px",
            padding: "5px",
            width: "50%",
            height: "auto",
        }
    });

    const renderValue = (val: any) => {
        if (!val) return "BRAK";
        return val;
    };

    return (
        <View style={styles.center}>
            <Text style={styles.border}>{name}</Text>
            <Text style={styles.border}>{renderValue(value)}</Text>
        </View>
    );
}
